(() => {
  'use strict';
  if (window.__ROCKY_RK5_CARDS__) return;
  window.__ROCKY_RK5_CARDS__ = true;

  const FAVORITES_KEY = 'rocky-favorites-v1';
  const $ = (selector, root = document) => root?.querySelector(selector) || null;
  const $$ = (selector, root = document) => (root ? [...root.querySelectorAll(selector)] : []);

  const readFavorites = () => {
    try {
      const value = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === 'string' && item))] : [];
    } catch {
      return [];
    }
  };

  const writeFavorites = favorites => {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify([...new Set(favorites)]));
  };

  const showToast = message => {
    const toast = $('[data-rk4-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(Number(toast.dataset.rk5Timer || 0));
    const timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
    toast.dataset.rk5Timer = String(timer);
  };

  const syncFavorites = root => {
    const favorites = readFavorites();
    $$('[data-rk5-favorite]', root).forEach(button => {
      const active = favorites.includes(button.dataset.handle || '');
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
  };

  const closePanel = (card, restoreFocus = false) => {
    const panel = $('[data-rk5-quick-panel]', card);
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    $$('[data-rk5-quick-open]', card).forEach(button => button.setAttribute('aria-expanded', 'false'));
    const trigger = card._rk5LastTrigger;
    window.setTimeout(() => {
      panel.hidden = true;
      if (restoreFocus && trigger instanceof HTMLElement) trigger.focus({ preventScroll: true });
    }, 230);
  };

  const closeAllPanels = except => {
    $$('[data-rk5-card]').forEach(card => {
      if (card !== except) closePanel(card, false);
    });
  };

  // Performans: hızlı ekle paneli HTML'de <template> içinde gelir; ilk açılışta oluşturulur.
  const hydratePanel = (card, panel) => {
    const tpl = panel.querySelector(':scope > template[data-rk14-lazy]');
    if (!tpl) return;
    panel.replaceChildren(tpl.content.cloneNode(true));
    $$('[data-rk14-qopt]', card).forEach(group => {
      const chips = $$('[data-rk14-chip]', group);
      if (chips.length === 1) chips[0].setAttribute('aria-pressed', 'true');
    });
    if ($('[data-rk14-qopt]', card)) applyChips(card); else updateVariant(card);
  };

  const openPanel = (card, trigger) => {
    const panel = $('[data-rk5-quick-panel]', card);
    if (!panel) return;
    hydratePanel(card, panel);
    closeAllPanels(card);
    card._rk5LastTrigger = trigger;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    $$('[data-rk5-quick-open]', card).forEach(button => button.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => {
      panel.classList.add('is-open');
      $('[data-rk5-variant-select]', panel)?.focus({ preventScroll: true });
    });
  };

  const updateVariant = card => {
    const select = $('[data-rk5-variant-select]', card);
    const option = select?.selectedOptions?.[0];
    if (!option) return;
    syncChips(card);
    if (!option.value) {
      // Henüz seçim yok: fiyatı koru, sepete ekle/satın al pasif
      $$('[data-rk5-buy]', card).forEach(button => { button.disabled = true; });
      $$('[data-rk5-add-button]', card).forEach(button => {
        button.disabled = true;
        const label = $('span', button);
        if (label) label.textContent = 'ÖNCE SEÇİM YAP';
      });
      return;
    }

    const variantId = option.value;
    const available = option.dataset.available === 'true';
    const price = option.dataset.price || '';
    const compare = option.dataset.compare || '';
    const image = option.dataset.image || '';

    $$('[data-rk5-variant-input]', card).forEach(input => {
      input.value = variantId;
    });
    $$('[data-rk5-buy]', card).forEach(button => {
      button.dataset.variantId = variantId;
      button.disabled = !available;
    });
    $$('[data-rk5-add-button]', card).forEach(button => {
      button.disabled = !available;
      const label = $('span', button);
      if (label) label.textContent = available ? 'SEPETE EKLE' : 'TÜKENDİ';
    });
    $$('[data-rk5-current-price], [data-rk5-quick-price]', card).forEach(node => {
      node.textContent = price;
    });
    const compareNode = $('[data-rk5-compare-price]', card);
    if (compareNode) {
      compareNode.textContent = compare;
      compareNode.hidden = !compare;
    }
    if (image) {
      const primary = $('.rk5-card__image--primary', card);
      if (primary instanceof HTMLImageElement) {
        primary.removeAttribute('srcset');
        primary.src = image;
      }
      const addComponent = $('add-to-cart-component', card);
      addComponent?.setAttribute('data-product-variant-media', image);
    }
  };

  // rk14: seçenek düğmeleri (renk / numara). Gizli <select> tek doğruluk kaynağı olarak kalır.
  const chipState = card => $$('[data-rk14-qopt]', card).map(group => {
    const pressed = $('[data-rk14-chip][aria-pressed="true"]', group);
    return pressed ? pressed.dataset.value : null;
  });

  const variantOptions = card => $$('[data-rk5-variant-select] option', card)
    .filter(option => option.value)
    .map(option => ({ option, values: (option.dataset.options || '').split('|'), available: option.dataset.available === 'true' }));

  const syncChips = card => {
    const groups = $$('[data-rk14-qopt]', card);
    if (!groups.length) return;
    const state = chipState(card);
    const variants = variantOptions(card);
    groups.forEach((group, index) => {
      $$('[data-rk14-chip]', group).forEach(chip => {
        // Diğer gruplardaki seçimlerle birlikte stokta varyant var mı?
        const ok = variants.some(v => v.available && v.values[index] === chip.dataset.value &&
          state.every((value, i) => i === index || value === null || v.values[i] === value));
        chip.classList.toggle('is-unavailable', !ok);
        chip.setAttribute('aria-disabled', String(!ok));
      });
      const label = $('[data-rk14-qsel]', group);
      if (label) label.textContent = state[index] ? `: ${state[index]}` : '';
    });
  };

  const applyChips = card => {
    const select = $('[data-rk5-variant-select]', card);
    if (!select) return;
    const state = chipState(card);
    const match = state.every(value => value !== null)
      ? variantOptions(card).find(v => v.values.every((value, i) => value === state[i]))
      : null;
    select.value = match && match.available ? match.option.value : '';
    updateVariant(card);
  };

  const initChips = root => {
    $$('[data-rk5-card]', root).forEach(card => {
      // Tek değerli grupları (ör. tek renk) otomatik seç
      $$('[data-rk14-qopt]', card).forEach(group => {
        const chips = $$('[data-rk14-chip]', group);
        if (chips.length === 1) chips[0].setAttribute('aria-pressed', 'true');
      });
      if ($('[data-rk14-qopt]', card)) applyChips(card);
    });
  };

  const cartAddEndpoint = () => {
    const base = String(window.RockyTheme?.cartAdd || '/cart/add').replace(/\/$/, '');
    return base.endsWith('.js') ? base : `${base}.js`;
  };

  const buyNow = async button => {
    const card = button.closest('[data-rk5-card]');
    const variantId = Number(button.dataset.variantId || $('[data-rk5-variant-input]', card)?.value || 0);
    if (!variantId || button.disabled) return;

    const previous = button.innerHTML;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'HAZIRLANIYOR…';

    try {
      const response = await fetch(cartAddEndpoint(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('cart-add-failed');
      const root = String(window.RockyTheme?.root || '/').replace(/\/$/, '');
      window.location.assign(`${root}/checkout`.replace(/^\/\//, '/'));
    } catch {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.innerHTML = previous;
      showToast('İŞLEM TAMAMLANAMADI. LÜTFEN TEKRAR DENE.');
    }
  };

  document.addEventListener('click', event => {
    const favorite = event.target.closest('[data-rk5-favorite]');
    if (favorite) {
      event.preventDefault();
      event.stopPropagation();
      const handle = favorite.dataset.handle || '';
      if (!handle) return;
      const favorites = readFavorites();
      const active = favorites.includes(handle);
      writeFavorites(active ? favorites.filter(item => item !== handle) : [...favorites, handle]);
      syncFavorites(document);
      showToast(active ? 'FAVORİLERDEN ÇIKARILDI' : 'FAVORİLERE EKLENDİ');
      return;
    }

    const opener = event.target.closest('[data-rk5-quick-open]');
    if (opener) {
      event.preventDefault();
      const card = opener.closest('[data-rk5-card]');
      if (card) openPanel(card, opener);
      return;
    }

    const closer = event.target.closest('[data-rk5-quick-close]');
    if (closer) {
      event.preventDefault();
      const card = closer.closest('[data-rk5-card]');
      if (card) closePanel(card, true);
      return;
    }

    const chip = event.target.closest('[data-rk14-chip]');
    if (chip) {
      event.preventDefault();
      if (chip.getAttribute('aria-disabled') === 'true') return;
      const group = chip.closest('[data-rk14-qopt]');
      const wasOn = chip.getAttribute('aria-pressed') === 'true';
      $$('[data-rk14-chip]', group).forEach(other => other.setAttribute('aria-pressed', 'false'));
      if (!wasOn || $$('[data-rk14-chip]', group).length === 1) chip.setAttribute('aria-pressed', 'true');
      const card = chip.closest('[data-rk5-card]');
      if (card) applyChips(card);
      return;
    }

    const buy = event.target.closest('[data-rk5-buy]');
    if (buy) {
      event.preventDefault();
      buyNow(buy);
      return;
    }

    if (!event.target.closest('[data-rk5-quick-panel]')) closeAllPanels(null);
  });

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-rk5-variant-select]');
    if (!select) return;
    const card = select.closest('[data-rk5-card]');
    if (card) updateVariant(card);
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openPanelNode = $('[data-rk5-quick-panel].is-open');
    const card = openPanelNode?.closest('[data-rk5-card]');
    if (card) closePanel(card, true);
  });

  document.addEventListener('cart:add', event => {
    const source = event.target?.closest?.('[data-rk5-card]');
    if (source) closePanel(source, false);
  });

  document.addEventListener('shopify:section:load', event => {
    syncFavorites(event.target);
    $$('[data-rk5-card]', event.target).forEach(updateVariant);
  });

  document.addEventListener('rocky:products-loaded', event => {
    syncFavorites(event.detail.root);
    $$('[data-rk5-card]', event.detail.root).forEach(updateVariant);
  });

  const init = () => {
    syncFavorites(document);
    $$('[data-rk5-card]').forEach(updateVariant);
    initChips(document);
  };

  document.addEventListener('rocky:products-loaded', event => initChips(event.detail?.root || document));
  document.addEventListener('shopify:section:load', event => initChips(event.target));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
